import axios from "../api";
// Gives up the club claim (backend ADR 0030): the imported club goes, the balance stays.
export const unlinkClub = async () => {
    try {
        await axios.post("/user-clubs/unlink");
    }
    catch (error) {
        // 404: no club linked, so it was already unlinked (e.g. on another device)
        if (error?.response?.status !== 404)
            throw error;
    }
};
export default unlinkClub;
//# sourceMappingURL=unlinkClub.js.map